export default __webpack_public_path__ + "static/media/uploader-oneTouchVerio-1.298a10b1.png";